import Grades from "./grades";

export default Grades;
